"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*global Promise*/
function Deferred() {

    this.promise = new _promise2.default(function (resolve, reject) {
        this._resolve = resolve;
        this._reject = reject;
    }.bind(this));
}

Deferred.prototype.resolve = function (value) {
    this._resolve.call(this.promise, value);
};

Deferred.prototype.reject = function (reason) {
    this._reject.call(this.promise, reason);
};

/* 对promise的简单封装，使其类似于$.deferred对象 */
exports.default = Deferred;
module.exports = exports["default"];